import React from 'react';

function MainSectionBranco() {
  return (
    <main style={styles.container}>
      <section id='section-about' style={styles.section}>
        <h1 style={styles.title}>Bem-vindo ao InovaCodigo</h1>
        <p style={styles.text}>
          Sou um desenvolvedor freelance especializado em criar soluções web inovadoras. 
        </p>
        <p style={styles.text}>
            No InovaCodigo, meu objetivo é transformar suas ideias em websites dinâmicos, responsivos e de alta performance. Se você está procurando uma solução personalizada, estou aqui para ajudar a dar vida ao seu projeto!
        </p>
      </section>
    </main>
  );
}

const styles = {
  container: {
    backgroundColor: '#F5F5F5', // Cor de fundo suave
    padding: '50px 20px',
    textAlign: 'center',
  },
  section: {
    maxWidth: '800px',
    margin: '0 auto',
  },
  title: {
    fontSize: '32px',
    color: '#000', // Texto preto
    fontWeight: 'bold',
  },
  text: {
    fontSize: '18px',
    color: '#333', // Cinza escuro para contraste
    lineHeight: '1.5',
    marginTop: '20px',
  },
};

export default MainSectionBranco;
